import { useEffect, useRef, useState } from "react";
import CommonTable from "../../../components/comman/CommonTable";
import MainHeading from "../../../components/comman/MainHeading";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { callApi } from "../../../ApiHelper/ApiHelper";
import moment from "moment";
import { Nav, NavItem, NavLink, TabContent, Fade, TabPane } from "reactstrap";
import FilterComponent from "../../../components/comman/FilterComponent";
import { useDispatch, useSelector } from "react-redux";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { useNavigate } from "react-router-dom";
import { formatAmount } from "../../../utility/CommonFunctions";
import {
  saveActivePtAgainstPoTab,
  updateFiltersStates,
} from "../../../store/actions/UserActions";
import { PaymentSummaryCard } from "./PaymentSummaryCard";
import { toast } from "react-toastify";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";

export default function PaymentTicketAll() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isFirstYearChange, setIsFirstYearChange] = useState(true);
  const ActiveTab = useSelector((state) => state?.root?.activePtAgainstPoTab);
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    filterData: "",
    month: "",
    paymentTicketList: [],
    searchQuery: "",
    status: ActiveTab,
    siteId: filterDetails?.siteId,
    siteList: [],
    companyList: [],
    companyIsLoading: false,
    isLoadingSite: false,
    isInitial: true,
    downloadLoading: false,
    cardsData: {
      totalPaymentAmount: 0,
      totalPaymentCount: 0,
      totalPaidAmount: 0,
      totalPaidCount: 0,
      partialRemainingAmount: 0,
      partialRemainingCount: 0,
      inProgressAmount: 0,
      inProgressCount: 0,
      pendingAmount: 0,
      pendingCount: 0,
    }
  });
  const userDetails = useSelector((state) => state.root.userDetails);
  const timeoutId = useRef(null);

  const [selectedRows, setSelectedRows] = useState([]);

  const handleSelectionChange = (checked, pageRowIds) => {
    if (checked) {
      const newSelected = [...new Set([...selectedRows, ...pageRowIds])];
      setSelectedRows(newSelected);
    } else {
      setSelectedRows([]);
    }
  };

  useEffect(() => {
    GetSiteList(filterDetails?.companyId);
  }, [filterDetails?.companyId]);

  useEffect(() => {
    if (filterDetails?.year) {
      GetPaymentTicket(filterDetails?.currentPage);
    }
  }, [
    filterDetails?.currentPage,
    ActiveTab,
    pageStates.searchQuery,
    filterDetails?.sortByDate,
    filterDetails?.year,
    filterDetails.pageSize,
    filterDetails?.siteId,
    pageStates?.status,
    filterDetails?.companyId,
    filterDetails?.vendorId,
    filterDetails?.orderBy,
    pageStates?.isInitial,
    filterDetails?.paymentStatus,
    filterDetails?.expenseHeadId,
    filterDetails?.createdById,
    filterDetails?.expenseMonth,
  ]);

  useEffect(() => {
    GetCompanyList();
    GetExpenseHead();
    GetCreatedBy();
  }, []);


  const GetPaymentTicket = () => {
    let options = {
      method: "GET",
    };
    const filterData = {
      status: pageStates?.status,
      searchQuery: pageStates?.searchQuery,
      siteId: pageStates?.siteId,
      paymentStatus: ActiveTab == "approved" ? filterDetails?.paymentStatus : "",
      ...filterDetails,
      expenseMonth: filterDetails?.expenseMonth || "",
      includeExpenseMonth: true,
    };
    // console.log("filter>>", filterData)
    const Url = apiUrl.get_payment_ticket + MainFilterHandler(filterData);
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.paymentTicket?.map((item) => ({
          ...item,
          siteName: item?.site?.name,
          paymentDate: moment(item?.date).format("DD-MM-YYYY"),
          ExpenseMonth: item?.expenseMonth ? moment(item?.expenseMonth).format("MM/YYYY") : "--",
          createdBy: item?.user?.name,
          paymentTicketStatus: item?.status,
          grandTotal: formatAmount(item?.totalAmount),
          paymentTicketType: item?.type,
          expenseName:
            item?.paymentticketexpenseheads[0]?.expensehead?.name +
            `${item?.paymentticketexpenseheads?.length > 1
              ? ` + ${item?.paymentticketexpenseheads?.length - 1}`
              : ""
            }`,
          payTerms: item?.purchase?.paymentTerms,
          remaining: formatAmount(item?.remainingAmount),
          paidAmount: formatAmount(item?.totalAmount - item?.remainingAmount),
        }));
        setPageStates((pre) => ({
          ...pre,
          paymentTicketList: newData,
          cardsData: {
            totalPaymentAmount: res?.data?.totalPaymentAmount,
            totalPaymentCount: res?.data?.totalPaymentCount,
            totalPaidAmount: res?.data?.totalPaidAmount,
            totalPaidCount: res?.data?.totalPaidCount,
            partialRemainingAmount: res?.data?.partialRemainingAmount,
            partialRemainingCount: res?.data?.partialRemainingCount,
            inProgressAmount: res?.data?.inProgressAmount,
            inProgressCount: res?.data?.inProgressCount,
            pendingAmount: res?.data?.pendingAmount,
            pendingCount: res?.data?.pendingCount,
          }
        }));
        dispatch(
          updateFiltersStates({
            count: res?.data?.pageInfo?.total,
            totalPages: res?.data?.pageInfo?.totalPages,
          })
        );
      }
    });
  };

  const GetCompanyList = (inputValue) => {
    return new Promise((resolve) => {
      let API = `${apiUrl.get_company}${inputValue ? `?search=${inputValue}` : ""
        }`;
      let options = { method: "GET" };
      setPageStates((prev) => ({
        ...prev,
        companyIsLoading: true,
      }));
      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            const formattedData = response?.data?.company.map((company) => ({
              value: company.id,
              label: company.name,
            }));

            setPageStates((prev) => ({
              ...prev,
              companyIsLoading: false,
              companyList: formattedData,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const toggleTab = (tab) => {
    dispatch(saveActivePtAgainstPoTab(tab));
    setSelectedRows([]);
    setPageStates((prev) => ({
      ...prev,
      status: tab,
    }));
    dispatch(
      updateFiltersStates({
        currentPage: 1,
        companyId: "",
        vendorId: "",
        expenseMonth: "",
      })
    );
    if (pageStates?.siteList?.length == 0) {
      GetSiteList();
    }
  };

  const TableHeading = [
    { value: "ticketNumber", label: "Ticket Number" },
    { value: "siteName", label: "Site Name" },
    { value: "paymentDate", label: "Date" },
    { value: "ExpenseMonth", label: "Expense Month" },
    { value: "expenseName", label: "Expense Name" },
    { value: "createdBy", label: "Created By" },
    { value: "paymentTicketType", label: "Type" },
    { value: "grandTotal", label: "Total Amount" },
    ...(ActiveTab === "approved"
      ? [{ value: "payTerms", label: "Payment Term" }]
      : []),
    ...(ActiveTab === "approved"
      ? [{ value: "remaining", label: "Payable  Amount" }]
      : []),
    ...(ActiveTab === "approved"
      ? [{ value: "paidAmount", label: "Paid  Amount" }]
      : []),
    ...(ActiveTab === "approved"
      ? [{ value: "paymentStatus", label: "Payment Status" }]
      : []),
    { value: "paymentTicketStatus", label: "Status" },
  ];

  const HandleView = (data) => {
    const type = data?.type
      ? data.type.charAt(0).toLowerCase() + data.type.slice(1)
      : "";

    navigate(`${RoutesLink.payment_tickets_details}/${type}/${data?.id}`);
  };

  const ActionData = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
  ];

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= filterDetails?.totalPages) {
      dispatch(
        updateFiltersStates({
          currentPage: PageNo,
        })
      );
    }
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 500);
  };

  const handleChangePageSize = (value) => {
    dispatch(
      updateFiltersStates({
        pageSize: value,
        currentPage: 1,
      })
    );
  };

  const dateChangeHandler = (Dates) => {
    // console.log(Dates);
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);
    if (formattedDate !== null) {
      dispatch(
        updateFiltersStates({
          sortByDate: formattedDate,
        })
      );
    } else {
      dispatch(
        updateFiltersStates({
          sortByDate: "",
        })
      );
    }
  };

  const GetSiteList = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      let API =
        userDetails?.type === 2
          ? apiUrl.get_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`
          : apiUrl.get_user_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`;

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item?.site?.id || item.id,
              label: item?.site?.name || item.name,
            }));

            const isSitePresent = response.data?.site?.some((item) => {
              const id = item?.site?.id || item.id;
              return id == filterDetails?.siteId;
            });

            setPageStates((prev) => ({
              ...prev,
              ...(isSitePresent ? { isInitial: false } : { siteId: "" }),
              siteList: formattedData || [],
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const GetExpenseHead = (inputValue) => {
    return new Promise((resolve) => {
      let options = {
        method: "GET",
      };
      const Url = `${apiUrl.get_expense_head}${inputValue ? `?search=${inputValue}` : ""}`;
      callApi(Url, options).then((res) => {
        if (res?.status === true) {
          const newData = res?.data?.expenseHead?.map((item) => ({
            value: item?.id,
            label: item?.name,
          }));
          setPageStates((pre) => ({
            ...pre,
            expenseHeadList: newData,
          }));
          resolve(newData);
        } else {
          resolve([]);
        }
      }).catch(() => {
        resolve([]);
      });
    });
  };

  const GetCreatedBy = (inputValue) => {
    return new Promise((resolve) => {
      let options = {
        method: "GET",
      };
      const Url = `${apiUrl.get_employee}?status=current&type=1${inputValue ? `&search=${inputValue}` : ""}`;
      callApi(Url, options).then((res) => {
        if (res?.status === true) {
          const newData = res?.data?.user?.map((item) => ({
            value: item?.id,
            label: item?.name,
          }));
          setPageStates((pre) => ({
            ...pre,
            createdByList: newData,
          }));
          resolve(newData);
        } else {
          resolve([]);
        }
      }).catch(() => {
        resolve([]);
      });
    });
  };

  const sortList = {
    site: pageStates?.siteList,
    isShow: "show",
    ...(ActiveTab == "approved"
      ? {
        autoSiteSelector: () => {
          return (
            <div className="d-flex align-items-center">
              <select
                className="form-select pe-5"
                style={{ cursor: "pointer" }}
                onChange={(e) => {
                  dispatch(
                    updateFiltersStates({
                      paymentStatus: e.target.value,
                    })
                  );
                }}
                value={filterDetails?.paymentStatus ?? ""}
              >
                <option value={""} hidden>
                  Select Payment Status
                </option>
                <option value={""}>All</option>
                <option value={"pending"}>Pending</option>
                <option value={"inProgress"}>In Progress</option>
                <option value={"completed"}>Full Payment</option>
                <option value={"partial"}>Part Payment</option>
              </select>
            </div>
          );
        },
      }
      : {}),
    companyList: pageStates?.companyList,
  };

  const handleSortData = (data, type) => {
    setPageStates((prevState) => ({
      ...prevState,
      ...(type === "site" && { siteId: data?.site }),
      ...(type === "companyId" && { companyId: data?.companyId }),
      ...(type == "companyId" && {
        siteId: "",
      }),
    }));
    dispatch(
      updateFiltersStates({
        ...(type === "site" && { siteId: data?.site }),
        ...(type == "companyId" && { companyId: data?.companyId, siteId: "" }),
        ...(type === "expenseHeadId" && { expenseHeadId: data?.expenseHeadId }),
        ...(type === "createdById" && { createdById: data?.createdById }),
      })
    );
  };

  const handleYearChange = (selectedYear) => {
    dispatch(
      updateFiltersStates({
        year: selectedYear,
        sortByDate: isFirstYearChange ? filterDetails.sortByDate : [],
      })
    );

    if (isFirstYearChange) {
      setIsFirstYearChange(false);
    }
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  const handleExportPT = async () => {
    const submitData = {
      paymentTicketIds: selectedRows,
    };
    let options = {
      method: "POST",
      data: submitData,
    };

    const API = apiUrl?.export_payment_ticket;
    try {
      setPageStates((pre) => ({
        ...pre,
        downloadLoading: true,
      }));
      const response = await callApi(API, options);
      setPageStates((pre) => ({
        ...pre,
        downloadLoading: false,
      }));
      if (response?.status === true && response?.data) {
        const fileUrl = response?.data;
        const fileName = `Payment_Tickets_Export.xlsx`;

        const fileResponse = await fetch(fileUrl);

        if (!fileResponse.ok) {
          throw new Error("Failed to fetch the file for download");
        }

        const blob = await fileResponse.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // clean up
        setSelectedRows([]);
      } else {
        toast.error(response?.message || "Failed to fetch file URL");
      }
    } catch (err) {
      console.error(err);
      toast.error("Download failed. Please try again.");
      setPageStates((pre) => ({
        ...pre,
        downloadLoading: false,
      }));
    }
  };

  return (
    <>
      {pageStates?.downloadLoading && BgBlurLoader()}
      <div className="content">
        <MainHeading
          title={"All Payment Tickets"}
          dateChangeHandler={dateChangeHandler}
          handleYearChange={handleYearChange}
        />
        {(ActiveTab === "approved" && (userDetails?.designation?.name === "Director" || userDetails?.department?.name === "Account")) &&
          <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xl-5 dash-cards g-3 mb-4">
            <PaymentSummaryCard
              title="Total Payment"
              primaryValue={formatAmount(pageStates?.cardsData?.totalPaymentAmount)}
              secondaryText={`${pageStates?.cardsData?.totalPaymentCount} ticket(s)`}
              badge={{ label: "Total", className: "bg-blue-25" }}
            />
            <PaymentSummaryCard
              title="Total Paid"
              badge={{ label: "Paid", className: "bg-green-25" }}
              primaryValue={formatAmount(pageStates?.cardsData?.totalPaidAmount)}
              secondaryText={`${pageStates?.cardsData?.totalPaidCount} ticket(s)`}
            />
            <PaymentSummaryCard
              title="Partial remaining"
              badge={{ label: "Partial", className: "bg-aqua-25" }}
              primaryValue={formatAmount(pageStates?.cardsData?.partialRemainingAmount)}
              secondaryText={`${pageStates?.cardsData?.partialRemainingCount} ticket(s)`}
            />
            <PaymentSummaryCard
              title="In Progress"
              badge={{ label: "In Progress", className: "bg-grey-25" }}
              primaryValue={formatAmount(pageStates?.cardsData?.inProgressAmount)}
              secondaryText={`${pageStates?.cardsData?.inProgressCount} ticket(s)`}
              metaOnTop
              largeValue
            />
            <PaymentSummaryCard
              title="Pending Payments"
              badge={{ label: "Pending", className: "bg-yellow-25" }}
              primaryValue={formatAmount(pageStates?.cardsData?.pendingAmount)}
              secondaryText={`${pageStates?.cardsData?.pendingCount} ticket(s) unpaid`}
            />
          </div>}
        <div className="d-flex align-items-center justify-content-between">
          <Nav tabs className="nav nav-tabs border-0 mb-4">
            <NavItem className="nav-item">
              <NavLink
                className={
                  ActiveTab === "pending"
                    ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-2 border-start-2 active"
                    : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-2 border-start-2"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab("pending")}
              >
                Pending
              </NavLink>
            </NavItem>
            <NavItem className="nav-item ">
              <NavLink
                className={
                  ActiveTab === "approved"
                    ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-0 active"
                    : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-0"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab("approved")}
              >
                Approved
              </NavLink>
            </NavItem>
            <NavItem className="nav-item ">
              <NavLink
                className={
                  ActiveTab === "rejected"
                    ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0 active"
                    : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab("rejected")}
              >
                Rejected
              </NavLink>
            </NavItem>
          </Nav>
          {(ActiveTab === "approved" || ActiveTab === "pending") && (
            <button className="btn btn-primary"
              disabled={selectedRows.length === 0}
              onClick={handleExportPT}>
              Export
            </button>
          )}
        </div>
        {selectedRows?.length > 0 && (ActiveTab === "approved" || ActiveTab === "pending") && (
          <div className="alert alert-info d-flex justify-content-center align-items-center p-2 px-3 rounded-3">
            <div className="d-flex align-items-center gap-2">
              <i className="bi bi-check-circle-fill text-success fs-5"></i>
              <span className=" fs-5">
                Selected <strong>{selectedRows.length}</strong> of Total{" "}
                <strong>{filterDetails?.count}</strong> Payment Tickets to
                Export
              </span>
            </div>
          </div>
        )}
        <TabContent activeTab={ActiveTab}>
          <TabPane tabId={"pending"}>
            <Fade in={ActiveTab === "pending"} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    handleSearch={handleSearchChange}
                    filterArray={sortList}
                    handleData={handleSortData}
                    pageStates={pageStates}
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    getSite={GetSiteList}
                    getCompany={GetCompanyList}
                    expenseMonthFilter={true}
                  />
                  <CommonTable
                    TableHeading={TableHeading}
                    TableData={pageStates?.paymentTicketList}
                    ActionData={ActionData}
                    currentPage={filterDetails?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={filterDetails?.totalPages}
                    count={filterDetails?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={filterDetails.pageSize}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    onSelectionChange={handleSelectionChange}
                    rowKey="id"
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
          <TabPane tabId={"approved"}>
            <Fade in={ActiveTab === "approved"} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    handleSearch={handleSearchChange}
                    filterArray={sortList}
                    handleData={handleSortData}
                    pageStates={pageStates}
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    getSite={GetSiteList}
                    getCompany={GetCompanyList}
                    getExpense={GetExpenseHead}
                    getUser={GetCreatedBy}
                    expenseMonthFilter={true}
                  />
                  <CommonTable
                    TableHeading={TableHeading}
                    TableData={pageStates?.paymentTicketList}
                    ActionData={ActionData}
                    currentPage={filterDetails?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={filterDetails?.totalPages}
                    count={filterDetails?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={filterDetails.pageSize}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    onSelectionChange={handleSelectionChange}
                    rowKey="id"
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
          <TabPane tabId={"rejected"}>
            <Fade in={ActiveTab === "rejected"} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    handleSearch={handleSearchChange}
                    filterArray={sortList}
                    handleData={handleSortData}
                    pageStates={pageStates}
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    getSite={GetSiteList}
                    getCompany={GetCompanyList}
                    expenseMonthFilter={true}
                  />
                  <CommonTable
                    TableHeading={TableHeading}
                    TableData={pageStates?.paymentTicketList}
                    ActionData={ActionData}
                    currentPage={filterDetails?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={filterDetails?.totalPages}
                    count={filterDetails?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={filterDetails.pageSize}
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
        </TabContent>
      </div>
    </>
  );
}